import { GridColDef } from "@mui/x-data-grid";
import { CSSProperties, IconButton, Tooltip } from "@mui/material";
import ItemStatus from "../../../../../../common/components/item_status";
import dataUtils from "../../../../../../common/utils/dataUtils";
import DynamicIcon from "../../../../../../components/global/DynamicIcon";



/**
 * GenerateObrasColumnDefinition
 */

type Props = {
  onActionEditar: (idEquipMedicao: number | null, openState: boolean) => void;
  onActionDeletar: (idEquipMedicao: number | null, openState: boolean) => void;
  onActionCopy: (idEquipMedicao: number | null, openState: boolean) => void;
};

export const GenerateControleColumnDefinition = ({
  onActionEditar,
  onActionDeletar,
  onActionCopy,
}: Props): GridColDef[] => {
  const computeItemStatusTitle = (status: string) => {
    switch (status) {
      case "A":
        return "A";
      case "E":
        return "E";
      default:
        return "?";
    }
  };

  const computeItemStatusColor = (status: string) => {
    switch (status) {
      case "A":
        return "red";
      case "E":
        return "yellow";
      default:
        return "blue";
    }
  };

  const computeItemStatusDescription = (status: string) => {
    switch (status) {
      case "A":
        return "Atrasado";
      case "E":
        return "Em Dia";
      default:
        return "?";
    }
  };

  const computeTipoClass = (tipo: string) => {
    switch (tipo) {
      case "Verificado": return 'bg-[#45b6af] text-white py-[.1rem] px-[.4rem] text-[0.70rem]';
      case "Calibrado": return 'bg-[#f8cb00] text-black py-[.1rem] px-[.4rem] text-[0.70rem]';
      default: return '';
    }
  }

  const computeTipoLabel = (tipo: string): string => {
    return tipo;
  }


  return [
    {
      field: "status",
      filterable: false,
      headerName: "Status",
      minWidth: 50,
      width: 50,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            textSize="small"
            title={computeItemStatusTitle(params.value)}
            color={computeItemStatusColor(params.value)}
            description={computeItemStatusDescription(params.value)}
          />
        </div>
      )
    },
    {
      field: "cor",
      filterable: false,
      headerName: "Cor",
      width: 40,
      minWidth: 40,
      sortable: false,
      valueGetter: (_, row) => ({ cor: row['cor'], corValor: row['corValor'], tipo: row['tipo'] }),
      renderCell: ({ value }) => {
        return (
          <div className="size-full flex flex-col justify-center py-1">
            {
              value.tipo === "Verificado" &&
              <>
                <Tooltip title={value['cor'] ?? "Nenhuma"}>
                  <div
                    style={{
                      backgroundColor: value['corValor'] as CSSProperties['color'] ?? 'transparent',
                    }}
                    className="h-[1.85rem] w-[1.0rem] rounded flex flex-col gap-0 justify-center items-center border">
                    <div className="flex flex-col gap-0 justify-center items-center"></div>
                  </div>
                </Tooltip>
              </>
            }
          </div>
        );
      },
    },
    {
      field: "tipo",
      filterable: false,
      headerName: "Tipo",
      width: 80,
      minWidth: 80,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="size-full flex flex-col justify-center py-1">
            <span className={computeTipoClass(value)}>
              {computeTipoLabel(value)}
            </span>
          </div>
        );
      },
    },
    {
      field: "equipamento",
      filterable: false,
      headerName: "Equipamento",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="size-full flex flex-col justify-center py-1">
            {value}
          </div>
        );
      },
    },
    {
      field: "responsavelPeloEquipamento",
      filterable: false,
      headerName: "Responsável pelo Equipamento",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="size-full flex flex-col justify-center py-1">
            {value}
          </div>
        );
      },
    },
    {
      field: "dataCalibracaoVerificacao",
      filterable: false,
      headerName: "Data Calibração / Verificação",
      width: 85,
      minWidth: 85,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="size-full flex flex-col justify-center py-1">
            {dataUtils.dataFormatada(value ? value : null)}
          </div>
        );
      },
    },
    {
      field: "frequencia",
      filterable: false,
      headerName: "Frequência",
      width: 80,
      minWidth: 80,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="size-full flex flex-col justify-center py-1">
            {value !== null && value !== undefined ? `${value} ${value > 1 ? "dias" : "dia"}` : "-"}
          </div>
        );
      },
    },
    {
      field: "proximaCalibracaoVerificacao",
      filterable: false,
      headerName: "Próxima Calibração / Verificação",
      width: 85,
      minWidth: 85,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="size-full flex flex-col justify-center py-1">
            {dataUtils.dataFormatada(value ? value : null)}
          </div>
        );
      },
    },
    {
      field: "calibradoVerificadoPor",
      filterable: false,
      headerName: "Calibrado / Verificado Por",
      width: 185,
      minWidth: 185,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="size-full flex flex-col justify-center py-1">
            {value}
          </div>
        );
      },
    },
    {
      field: "centroDeCusto",
      filterable: false,
      headerName: "Centro de Custo",
      width: 150,
      minWidth: 150,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="size-full flex flex-col justify-center py-1">
            {value}
          </div>
        );
      },
    },
    {
      field: 'idEquipMedicao',
      headerName: 'Ações',
      sortable: false,
      filterable: false,
      width: 125,
      renderCell: (params) => (
        <div className="flex items-center justify-center w-full h-full gap-1">
          <IconButton onClick={() => onActionEditar(params.row.idEquipMedicao, true)}>
            <DynamicIcon nameIcon="EditRounded" size={20} className="dark:text-white text-primary-green" />
          </IconButton>

          <Tooltip title="Copiar Equipamento">
            <IconButton onClick={() => onActionCopy(params.row.idEquipMedicao, true)}>
              <DynamicIcon nameIcon="ContentCopyRounded" size={20} className="text-purple-500" />
            </IconButton>
          </Tooltip>

          <IconButton onClick={() => onActionDeletar(params.row.idEquipMedicao, true)}>
            <DynamicIcon nameIcon="DeleteForeverRounded" size={20} className="text-red-500" />
          </IconButton>
        </div>
      ),
    },
  ];
}